export default __webpack_public_path__ + "images/selectPatientClose.cce13df28d199b14bd97579ee5e8898c.svg";